export default __webpack_public_path__ + "static/media/TITULOS_06.da4652b0.png";